module.exports = __webpack_public_path__ + "static/media/logout_icon_hover.eef3b823.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logout_icon_hover.svg
// module id = 170
// module chunks = 0